<template>
  <span class="material-symbols-rounded text-primary"> work </span>
</template>

<script setup></script>
